<template>
    <BModal :model-value="modal" centered @update:modelValue="updateModal" scrollable no-close-on-backdrop>
        <template #header>
            <div
                class="d-flex align-items-center justify-content-between modal-title w-100"
            >
                <h5 class="">Activity</h5>
                <BButton
                    variant="link"
                    class="close"
                    @click="updateModal(false)"
                >
                    <i class="ion ion-android-close"></i>
                </BButton>
            </div>
        </template>

        <BForm @submit.stop.prevent>
        
                <BRow>
                    <BCol>
                        <BFormGroup
                            label="Destination *"
                            label-for="destination"
                            class="text-start mb-3"
                        >
                            <v-select
                                v-model="form.destination_uuid"
                                label="name"
                                :options="destinationList"
                                :reduce="(item) => item.uuid"
                                :searchable="true"
                                :clearable="true"
                                placeholder="Select Destination"
                                :class="{
                                    'is-invalid':
                                        v$.form.destination_uuid.$dirty &&
                                        v$.form.destination_uuid.$invalid,
                                }"
                            />
                            <BFormInvalidFeedback
                                :state="
                                    v$.form.destination_uuid.$dirty &&
                                    v$.form.destination_uuid.$invalid
                                "
                            >
                                {{
                                    v$.form.destination_uuid.$errors[0]
                                        ?.$message
                                }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                    </BCol>
                </BRow>
         
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Name *"
                        label-for="name"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.name"
                            type="text"
                            id="name"
                            placeholder="Enter Name"
                            :class="{
                                'is-invalid':
                                    v$.form.name.$dirty &&
                                    v$.form.name.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.name.$dirty && v$.form.name.$invalid
                            "
                        >
                            {{ v$.form.name.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Description"
                        label-for="description"
                        class="text-start mb-3"
                    >
                        <BFormTextarea
                            v-model="form.description"
                            type="text"
                            id="description"
                            :rows="5"
                            placeholder="Enter Description"
                            :class="{
                                'is-invalid':
                                    v$.form.description.$dirty &&
                                    v$.form.description.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.description.$dirty &&
                                v$.form.description.$invalid
                            "
                        >
                            {{ v$.form.description.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Pax *"
                        label-for="pax"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.pax"
                            @update:modelValue="calculateSubtotal"
                            type="number"
                            id="pax"
                            placeholder="Enter Pax"
                            :class="{
                                'is-invalid':
                                    v$.form.pax.$dirty && v$.form.pax.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="v$.form.pax.$dirty && v$.form.pax.$invalid"
                        >
                            {{ v$.form.pax.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol>
                    <BFormGroup
                        label="Price Per Pax"
                        label-for="price"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.price"
                            @update:modelValue="calculateSubtotal"
                            type="number"
                            id="price"
                            placeholder="Enter Price"
                            :class="{
                                'is-invalid':
                                    v$.form.price.$dirty &&
                                    v$.form.price.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.price.$dirty && v$.form.price.$invalid
                            "
                        >
                            {{ v$.form.price.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Subtotal"
                        label-for="sub_total"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.sub_total"
                            @update:modelValue="calculatePrice"
                            type="number"
                            id="sub_total"
                            placeholder="Subtotal"
                        />
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Inclusion"
                        label-for="inclusion"
                        class="text-start mb-3"
                    >
                        <BFormTextarea
                            v-model="form.inclusion"
                            id="inclusion"
                            placeholder="Enter Inclusion"
                            :rows="5"
                            :class="{
                                'is-invalid':
                                    v$.form.inclusion.$dirty && v$.form.inclusion.$invalid,
                            }"
                        >
                        </BFormTextarea>
                        <BFormInvalidFeedback
                            :state="v$.form.inclusion.$dirty && v$.form.inclusion.$invalid"
                        >
                            {{ v$.form.inclusion.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Exclusion"
                        label-for="exclusion"
                        class="text-start mb-3"
                    >
                        <BFormTextarea
                            v-model="form.exclusion"
                            id="exclusion"
                            placeholder="Enter Exclusion"
                            :rows="5"
                            :class="{
                                'is-invalid':
                                    v$.form.exclusion.$dirty && v$.form.exclusion.$invalid,
                            }"
                        >
                        </BFormTextarea>
                        <BFormInvalidFeedback
                            :state="v$.form.exclusion.$dirty && v$.form.exclusion.$invalid"
                        >
                            {{ v$.form.exclusion.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
        </BForm>

        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" class="me-2" @click="handleAction"
                    >Save</BButton
                >
                <BButton variant="danger" @click="updateModal(false)"
                    >Cancel</BButton
                >
            </div>
        </template>
    </BModal>
</template>

<script setup>
import axios from "axios";
import { defineProps, defineEmits, reactive, watch, ref, onMounted } from "vue";
import {
    BModal,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BButton,
    BFormGroup,
    BFormInvalidFeedback,
    BFormTextarea,
} from "bootstrap-vue-next";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, minValue, minLength } from "@vuelidate/validators";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { useToast } from "vue-toastification";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const auth = useAuthStore();
const $loading = useLoading();
const toast = useToast();

// Props
const props = defineProps({
    action: String,
    modal: Boolean,
    selectedData: Object,
});

// Emit
const emit = defineEmits(["update:modal", "addOrUpdate"]);

// Function to update modal visibility
const updateModal = (value) => {
    emit("update:modal", value); // Sync modal state with parent
};

const resetForm = () => {
    Object.assign(form, { ...formData });
    v$.value.$reset();
};

const formData = {
    destination_uuid: "",
    name: "",
    description: "",
    price: "",
    pax: "",
    sub_total: "",
    inclusion: "",
    exclusion: "",
};

const form = reactive({ ...formData });

// Init data jika update
watch(
    () => props.selectedData,
    (newData) => {
        // jika props.selectedData != null (action edit)
        if (newData && Object.keys(newData).length > 0) {
            const activityData = {
                ...newData,
                destination_uuid: newData.destination?.uuid || null,
                description: newData.description === '-' ? '': newData.description
            };
            Object.assign(form, { ...activityData });
        } else {
            Object.assign(form, { ...formData });
        }
    },
    { immediate: true }
);

const calculateSubtotal = () => {
    if (form.pax && form.price) {
        form.sub_total = form.pax * form.price;
    } else {
        // If either is missing/zero, resetting subtotal might be annoying if typing,
        // but typically 0 makes sense or keep as is?
        // Let's stick to standard math: if one is 0/empty, result is 0
        if (!form.pax || !form.price) {
            form.sub_total = 0;
        }
    }
};

const calculatePrice = () => {
    if (form.pax && form.pax != 0 && form.sub_total) {
        form.price = Math.round(form.sub_total / form.pax);
    } else if (form.pax == 0 && form.sub_total) {
        // can't divide by zero
    } else {
        if (!form.sub_total) {
             // Optional: if subtotal clears, clear price? or keep price fixed?
             // User asked for "automatic", usually implies clear relationship.
             form.price = 0;
        }
    }
};

const rules = {
    form: {
        destination_uuid: {
            required: helpers.withMessage("Destination is required", required),
        },
        name: {
            required: helpers.withMessage("Name is required", required),
            minLength: helpers.withMessage(
                "Name must be at least 3",
                minLength(3)
            ),
        },
        description: {},
        pax: {
            required: helpers.withMessage("Pax is required", required),
            minValue: helpers.withMessage(
                "Pax must be at least 1",
                minValue(1)
            ),
        },
        price: {
        },
        inclusion: {},
        exclusion: {},
    },
};

const v$ = useVuelidate(rules, { form });

const handleAction = () => {
    props.selectedData.uuid ? update() : create();
};

const create = async () => {
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });

        try {
            const response = await axios.post(
                `${process.env.VUE_APP_API_URL}/activity/add`,
                {
                    destination_uuid: form.destination_uuid,
                    name: form.name,
                    description: form.description,
                    pax: form.pax,
                    price: form.price,
                    sub_total: form.sub_total,
                    inclusion: form.inclusion,
                    exclusion: form.exclusion,
                },
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                emit("addOrUpdate");
                toast.success(res.message);
                updateModal(false);
                resetForm();
            }
        } finally {
            loader.hide();
        }
    }
};

const update = async () => {
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });
        try {
            const response = await axios.put(
                `${process.env.VUE_APP_API_URL}/activity/edit/${props.selectedData.uuid}`,
                {
                    destination_uuid: form.destination_uuid,
                    name: form.name,
                    description: form.description,
                    pax: form.pax,
                    price: form.price,
                    sub_total: form.sub_total,
                    inclusion: form.inclusion,
                    exclusion: form.exclusion,
                },
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                emit("addOrUpdate");
                toast.success(res.message);
                updateModal(false);
                resetForm();
            }
        } finally {
            loader.hide();
        }
    }
};

let destinationList = ref([]);

const getAllDestination = async () => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/destination`,
            {
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            destinationList.value = res.data;
        }
    } finally {
        loader.hide();
    }
};

onMounted(() => {
    if (destinationList.value != null || destinationList.value != "") {
        getAllDestination();
    }
});
</script>
